export function fancyTimeFormat(duration: number): string {
	// Minutes and seconds
	const mins = Math.floor(duration / (60 * 1000));
	const secs = Math.floor((duration / 1000) % 60);

	const minutesSuffix = mins > 0 ? "Mins" : "Min";
	const secondsSuffix = "s";

	var output = "";

	if (!mins && !secs) {
		return `0 ${secondsSuffix}`;
	}

	if (mins) {
		output += `${mins} ${minutesSuffix} `;
	}

	if (secs) {
		output += `${secs} ${secondsSuffix} `;
	}

	return output;
}

export function formatOnlyMinutes(timeInMs: any): string {
	const minutes = Math.max(1, Math.floor(timeInMs / (60 * 1000)));
    return minutes > 1 ? `${minutes} Mins` : `${minutes} Min`
}

export function formatSecondsToMinutes(seconds: any): string {
	const minutes = Math.max(1, Math.floor(seconds / 60));
    return minutes > 1 ? `${minutes} Mins` : `${minutes} Min`
}